import events from '@/domain/events/engineeringModulesHeader';

export default {
  props: {
    showUpdateIcon: {
      type: Boolean,
      default: false,
    },
    showWifiIcon: {
      type: Boolean,
      default: false,
    },
    showInfoIcon: {
      type: Boolean,
      default: false,
    },
    showPrintIcon: {
      type: Boolean,
      default: false,
    },
    showTreeviewIcon: {
      type: Boolean,
      default: false,
    },
    updateEvent: {
      type: String,
      default: events.refresh,
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
};
